import api from '../api';

export interface DocumentacaoAcessoria {
  id: string;
  contratoId: string;
  aplicavel: boolean;
  dataValidade: Date;
  nome: string;
  numero: number;
  tipo: number;
}

export const getAllDocumentacaoAcessoriaByContrato = (contratoId: any) =>
  api.get<DocumentacaoAcessoria[]>(`documentacaoacessoria/contrato/${contratoId}`);
export const createDocumentacaoAcessoria = (contratoId: any, DocumentacaoAcessoria: DocumentacaoAcessoria) => {
  return api.post<DocumentacaoAcessoria>(`documentacaoacessoria/contrato/${contratoId}`, DocumentacaoAcessoria);
};
export const updateDocumentacaoAcessoria = (DocumentacaoAcessoria: DocumentacaoAcessoria) =>
  api.put(`documentacaoacessoria/${DocumentacaoAcessoria.id}`, DocumentacaoAcessoria);
export const deleteDocumentacaoAcessoria = (id: string) => api.delete(`documentacaoacessoria/${id}`);
export const updateDocumentoAcessorioAplicabilidade = (DocumentacaoAcessoria: DocumentacaoAcessoria) =>
  api.put(`documentacaoacessoria/contrato/${DocumentacaoAcessoria.contratoId}`, DocumentacaoAcessoria);



